"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_RULES_CANCEL = exports.FETCH_RULES_FAILED = exports.FETCH_RULES_SUCCESS = exports.FETCH_RULES_REQUEST = void 0;
exports.FETCH_RULES_REQUEST = '@teams/FETCH_RULES_REQUEST';
exports.FETCH_RULES_SUCCESS = '@teams/FETCH_RULES_SUCCESS';
exports.FETCH_RULES_FAILED = '@teams/FETCH_RULES_FAILED';
exports.FETCH_RULES_CANCEL = '@teams/FETCH_RULES_CANCEL';